import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { ActionOverlay } from 'components/ActionOverlay';
import { DEFAULT_TEXT } from '../strings';
import { SpecialSeatTypeOverlayProps, specialSeatTypesEnum } from '../types';

const SpecialSeatTypeOverlay = (props: SpecialSeatTypeOverlayProps) => {
  const { onCancel, onConfirm, seatClickedMessage } = props;
  const { t } = useTranslation();

  const specialSeatTypeToText: Record<(typeof specialSeatTypesEnum)[number], string> = {
    ADA: DEFAULT_TEXT.ada,
    ADA_COMPANION: DEFAULT_TEXT.adaCompanion,
    LIMITED_VIEW: DEFAULT_TEXT.limitedView,
    OBSTRUCTED_VIEW: DEFAULT_TEXT.obstructedView,
    STANDING_ROOM: DEFAULT_TEXT.standingRoom
  };

  const getTitle = () => {
    const specialSeatType = seatClickedMessage.seatType.specialHandling;
    const specialSeatTypeDescription = specialSeatType ? specialSeatTypeToText[specialSeatType] : DEFAULT_TEXT.unknown;

    return DEFAULT_TEXT.specialSeatTypeHeader.replace('{{specialSeatType}}', specialSeatTypeDescription);
  };

  return (
    <ActionOverlay
      title={getTitle()}
      cancelText={t('commonText.cancel')}
      confirmText={t('commonText.confirm')}
      onCancel={() => onCancel()}
      onConfirm={() => onConfirm()}
      height={500}
      style={{ background: 'rgba(255,255,255,0.95)' }}
    />
  );
};

export default SpecialSeatTypeOverlay;
